import { useCallback, useState } from "react";

const STORAGE_KEY = "edify-people-search-history";
const MAX_ITEMS = 8;

const readHistory = (): string[] => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((x): x is string => typeof x === "string") : [];
  } catch {
    return [];
  }
};

export const useSearchHistory = () => {
  const [history, setHistory] = useState<string[]>(readHistory);

  const addToHistory = useCallback((term: string) => {
    const trimmed = term.trim();
    if (!trimmed) return;
    const current = readHistory();
    const filtered = current.filter((t) => t.toLowerCase() !== trimmed.toLowerCase());
    const next = [trimmed, ...filtered].slice(0, MAX_ITEMS);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      setHistory(next);
    } catch {
      // ignore
    }
  }, []);

  const clearHistory = useCallback(() => {
    try {
      localStorage.removeItem(STORAGE_KEY);
      setHistory([]);
    } catch {
      // ignore
    }
  }, []);

  const refreshHistory = useCallback(() => {
    setHistory(readHistory());
  }, []);

  return { history, addToHistory, clearHistory, refreshHistory };
};
